import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryEmpty: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="battery-empty, power"><path fillRule="evenodd" clipRule="evenodd" d="M1 8.75C1 6.67893 2.67893 5 4.75 5H16.25C18.0642 5 19.5775 6.28832 19.925 8H20.75C21.9926 8 23 9.00736 23 10.25V13.75C23 14.9926 21.9926 16 20.75 16H19.925C19.5775 17.7117 18.0642 19 16.25 19H4.75C2.67893 19 1 17.3211 1 15.25V8.75ZM20 14.5H20.75C21.1642 14.5 21.5 14.1642 21.5 13.75V10.25C21.5 9.83579 21.1642 9.5 20.75 9.5H20V14.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBatteryEmpty;
